const { SelectControl } = wp.components;

const SelectMaxWidth = ({ attributes, setAttributes }) => {
  return (
    <SelectControl
      label="Selecione o tamanho máximo do conteúdo"
      title="Selecione o tamanho máximo do conteúdo"
      value={attributes.maxWidth}
      options={[
        { label: 'Tamanho do elemento pai', value: 'max-unset' },
        { label: '300px', value: 'max-small' },
        { label: '600px', value: 'max-medium' },
        { label: '900px', value: 'max-large' },
        { label: '1200px', value: 'max-ultraLarge' },
        { label: '20%', value: 'max-small-responsive' },
        { label: '40%', value: 'max-medium-responsive' },
        { label: '60%', value: 'max-large-responsive' },
        { label: '80%', value: 'max-ultraLarge-responsive' },
      ]}
      onChange={(position) => setAttributes({ maxWidth: position })}
    />
  );
};

export default SelectMaxWidth;
